import { lighten } from '@mui/system/colorManipulator';

export { lighten };

const colorManipulator = { lighten };

export default colorManipulator;
